// MCIP-14 — the reconciliation strip under the leaderboard. The pass-rate tile
// says "N failed"; the signal table may cover fewer (different scope, cluster
// attributed to another job, or failures never harvested). This section names
// that gap quietly — honest, not alarming — so the numbers always add up for
// the developer reading them.
import { unaccountedLabel, unaccountedNote, categoryLabel } from '../lib/unaccounted';

export default function UnaccountedFailures({ unaccounted }) {
  const label = unaccountedLabel(unaccounted);
  if (!label) return null;
  const note = unaccountedNote(unaccounted);

  return (
    <section className="unaccounted" aria-label="Failures not covered by any signal">
      <p className="unaccounted__lead">{label}</p>
      {unaccounted.sample?.length > 0 && (
        <ul className="unaccounted__list">
          {unaccounted.sample.map((f) => (
            <li key={f.failure_id}>
              <code>{f.test_name}</code>
              {f.failure_category && <span className="tag">{categoryLabel(f.failure_category)}</span>}
            </li>
          ))}
        </ul>
      )}
      {note && <p className="unaccounted__note">{note}</p>}
    </section>
  );
}
